import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'
import Table from '../../elements/Table'

import GoTo from '../../media/icons/icons8-share-96.png'

const Main = (props) => {

    const [tableTitles, setTableTitles] = useState([
        {
            title: 'ID',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: undefined,
        },
        {
            title: 'Name',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: undefined,
        },
        {
            title: 'Address',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: undefined,
        },
        {
            title: 'Contact',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: undefined,
        },
        {
            title: 'Goto',
            displayElement: (props) => (<Link to="/manage/spiffees"><IconButton image={GoTo} colors={props.colors} size="24px" Style={{padding: '3px', backgroundColor: props.colors.primary, borderRadius: '5px'}}></IconButton></Link>),
            default: undefined,
        },
    ])

    const [tableValues, setTableValues] = useState([
        [tableTitles[0].default], 
        [tableTitles[1].default],
        [tableTitles[2].default], 
        [tableTitles[3].default], 
        [tableTitles[4].default], 
    ])

    const [tableData, setTableData] = useState([
        [tableTitles[0].default],
        [tableTitles[1].default],
        [tableTitles[2].default],
        [tableTitles[3].default],
        [tableTitles[4].default],
    ])

    const [dropdownData, setDropdownData] = useState([
        [[]],
        [[]],
        [[]],
        [[]], //admin
        [[]], //contract type
    ])

    const [rowSelected, setRowSelected] = useState([false])

    const onTableChange = (e,x,y) => {
        console.log(e,x,y)
    }

    useEffect(() => {
        console.log(props.subagents[props.selectedSubagent].spiffee_IDs)
        let tempTableData = [
            [],
            [],
            [],
            [],
            [],
        ]
        let tempTableValues = [
            [],
            [],
            [],
            [],
            [],
        ]

        props.subagents[props.selectedSubagent].spiffee_IDs.map((spiffee, index) => {
            tempTableData[0].push(spiffee.code)
            tempTableData[1].push(spiffee.id)
            tempTableData[2].push(
                [
                    spiffee.address,
                    spiffee.city,
                    spiffee.state_code
                ].filter(value => value !== null) // Filter out null values
                .join(',')
            );
            tempTableData[3].push(spiffee.phone_number)
            tempTableData[4].push('-')

            tempTableValues[0].push(spiffee.code)
            tempTableValues[1].push(spiffee.name)
            tempTableValues[2].push(
                [
                    spiffee.address,
                    spiffee.city,
                    spiffee.state_code
                ].filter(value => value !== null) // Filter out null values
                .join(',')
            );
            tempTableValues[3].push(spiffee.phone_number)
            tempTableValues[4].push('-')
        })

        setTableValues(tempTableValues)
        setTableData(tempTableData)
    },[])

    const generateKey = () => {
        let tempNum = Math.random() * 100000
        console.log(tempNum)
        return (Math.round(tempNum) + 'F') ;
    }

    return (
        <div style={{width: 'auto', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Subagent Spiffees Modal</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column'}}>
                <Table colors={props.colors} keys={generateKey()} tableData={tableValues} tableInfo={tableTitles} dropdownData={dropdownData} rows={rowSelected} setRows={setRowSelected} onChange={onTableChange} selectMenu={false} key='Modal'></Table>
            </div>
        </div>
    )
}

export default Main
